import moment from "moment-timezone";

export function formatDate(date, format = "DD-MMM-YYYY HH:mm") {
  return moment(date).format(format);
}

export function formatDateLocal(date, format = "DD-MMM-YYYY HH:mm") {
  return moment.tz(date, moment.tz.guess()).format(format);
}
